import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";

const Tokens = ({ selectedToken, onChangeToken }) => {
  const radioOptions = [
    { label: "Gold", value: "Gold" },
    { label: "Silver", value: "Silver" },
    { label: "Bronze", value: "Bronze" },
  ];

  const initialState = radioOptions.reduce((acc, { value }) => {
    acc[value] = false;
    return acc;
  }, {});

  const [radioStates, setRadioStates] = useState(initialState);

  // const handleRadioChange = (radioValue) => {

  //   setRadioStates((prevStates) => ({
  //     ...prevStates,
  //     [radioValue]: !prevStates[radioValue],
  //   }));
  // };

  return (
    <div className="flex gap-8 ml-3 mb-4">
      <RadioGroup
        options={radioOptions.map(({ label, value }) => ({
          label,
          value,
        }))}
        onChange={onChangeToken}
        value={selectedToken}
      />
    </div>
  );
};

export default Tokens;
